import React from 'react';
import { Card } from 'primereact/card';
import { useLanguage } from '../../../contexts/LanguageContext';
import { PRIMARY, SectionTitle, LinkRow, cardStyle, cardPt } from '../components/LmsSectionCard';
import { useLmsPermission } from '../hooks/useLmsPermission';
import { LMS, LMS_TRAINING_MANAGE } from '../../../constants/permissionCodes';

// Eğitim Planlama (my-trainings) sayfasıyla aynı görsel desen: gri başlıklı kart + link satırları.
const ManagementPages = () => {
    const { th } = useLanguage();
    const { can } = useLmsPermission();

    const items = [
        { titleKey: 'trainingTypeDefinitions.title', icon: 'pi-tag', to: '/learning-management-system/training-type-definitions', codes: [LMS.DEFINITION_VIEW] },
        { titleKey: 'trainingLocationDefinitions.title', icon: 'pi-map-marker', to: '/learning-management-system/training-location-definitions', codes: [LMS.DEFINITION_VIEW] },
        { titleKey: 'preconditionDefinitions.title', icon: 'pi-shield', to: '/learning-management-system/precondition-definitions', codes: [LMS.DEFINITION_VIEW] },
        { titleKey: 'vehicleModelDefinitions.title', icon: 'pi-car', to: '/learning-management-system/vehicle-model-definitions', codes: [LMS.DEFINITION_VIEW] },
        { titleKey: 'vehicleTrainingMatch.title', icon: 'pi-sitemap', to: '/learning-management-system/vehicle-training-match', codes: LMS_TRAINING_MANAGE },
        { titleKey: 'lmsVideo.title', icon: 'pi-video', to: '/learning-management-system/lms-videos', codes: LMS_TRAINING_MANAGE },
        { titleKey: 'lmsTrainingDocument.title', icon: 'pi-file-pdf', to: '/learning-management-system/training-document', codes: LMS_TRAINING_MANAGE },
        { titleKey: 'lmsNews.managementTitle', icon: 'pi-megaphone', to: '/learning-management-system/news-management', codes: [LMS.NEWS_VIEW] }
    ].filter((item) => can(item.codes));

    return (
        <div>
            <h1 className="mb-4" style={{ color: PRIMARY }}>
                {th('menu.lmsManagementPages', { fallback: 'Yönetim Sayfaları' })}
            </h1>

            <div className="grid">
                <div className="col-12">
                    <Card style={cardStyle} pt={cardPt}>
                        <SectionTitle title={th('menu.lmsManagementPages', { fallback: 'Yönetim Sayfaları' })} />
                        {items.map((item, index) => (
                            <LinkRow key={item.titleKey} title={th(item.titleKey)} icon={item.icon} to={item.to} showDivider={index < items.length - 1} />
                        ))}
                    </Card>
                </div>
            </div>
        </div>
    );
};

export default ManagementPages;
